$(document).on("click", ".addreses_button", function () {
  $(this).parent().find(".edit-address-button").trigger("click");
});
$(document).on("click", ".side-panel-close-custom", function () {
  $("#side-panel-search-input").val("");
  $(".side-panel-content--has-tabs").removeClass("active");
});
$(document).on("click", ".custom_minus_button", function () {
  let removeButton = $(this).parent().parent().parent().find(".remove");

  if (removeButton.length) {
    removeButton[0].dispatchEvent(new Event("click", { bubbles: true }));
  }
});
setInterval(function () {
  const buttons = document.querySelectorAll(".single-add-to-cart-button--text");
  for (let i = 0; i < buttons.length; i++) {
    const button = buttons[i];
    const html = button.innerHTML.trim().toLowerCase();
    if (html === "sold out" || html === "coming soon") {
      button.parentNode.classList.add("soldout_button");
    } else {
      button.parentNode.classList.remove("soldout_button");
    }
  }
});
document.addEventListener("click", function (event) {
  if (event.target.closest(".iwish-row.iwishProduct-row")) {
    let productLink = event.target
      .closest(".iwish-row.iwishProduct-row")
      .querySelector(".product-title a");
    if (productLink) {
      productLink.click();
    }
  }
});

$(document).ready(function () {
  setTimeout(function () {
    $(".iwish-float-icon").trigger("click");
  }, 500);
  setTimeout(function () {
    var cartContent = $("body").find(".iwish-drawer-menu .drawer-body").html();
    $(".append_items_in").html(cartContent);
    console.log(cartContent);
    $(".iwish-row.iwish-prouctImg img").each(function () {
      var img = $(this);
      var src = img.attr("src");

      if (src.includes("x400")) {
        var newSrc = src.replace("x400", "x1024");
        img.attr("src", newSrc);
      }
    });
  }, 2500);
});

document.addEventListener("DOMContentLoaded", function () {
  const interval = setInterval(() => {
    const klarnaPlacement = document.querySelector("klarna-placement");

    if (klarnaPlacement && klarnaPlacement.shadowRoot) {
      const container = klarnaPlacement.shadowRoot.querySelector(".container.auto-size");

      if (container && !klarnaPlacement.classList.contains("styled")) {
        container.style.border = "unset";
        container.style.padding = "0px";
        container.style.textAlign = "left";

        const logo = container.querySelector(".logo");
        if (logo) {
          logo.style.fontSize = "13px";
        }

        klarnaPlacement.style.marginTop = "-7px";
        klarnaPlacement.style.display = "block";
        klarnaPlacement.classList.add("styled");

        const klarnaParent = klarnaPlacement.parentElement;
        if (klarnaParent && !klarnaParent.classList.contains("moved-klarna")) {
          const cloned = klarnaParent.cloneNode(true);
          cloned.classList.add("moved-klarna");
          klarnaParent.remove();

          const pickupAvailability = document.querySelector("pickup-availability");
          if (pickupAvailability) {
            pickupAvailability.parentNode.insertBefore(cloned, pickupAvailability);

            setTimeout(() => {
              const newKlarna = cloned.querySelector("klarna-placement");
              if (newKlarna && newKlarna.shadowRoot) {
                const newContainer = newKlarna.shadowRoot.querySelector(".container.auto-size");
                if (newContainer) {
                  newContainer.style.border = "unset";
                  newContainer.style.padding = "0px";
                  newContainer.style.textAlign = "left";

                  const newLogo = newContainer.querySelector(".logo");
                  if (newLogo) {
                    newLogo.style.fontSize = "13px";
                  }

                  newKlarna.style.marginTop = "-7px";
                  newKlarna.style.display = "block";
                }
              }
            }, 300); 
          }

          clearInterval(interval);
        }
      }
    }
  }, 300);
});



$(document).ready(function () {
  var item_product_title = $(".product-title-container h1").html();
  var item_product_color = $(
    ".variations .product-form__input--siblings label.active a"
  ).attr("title");
  var item_product_size = $(
    ".variations .product-form__input--block input[type=radio]:checked+label span"
  ).html();
  $(".item_product_title").html(item_product_title);
  $(".item_product_color").html(item_product_color);
  $(".item_product_size").html(item_product_size);
  $(".unavailable_pickup.custom_pickup_text").removeClass("custom_pickup_text");
  setTimeout(function(){
    $('.main_template #product_selected_or_first_available_variant_id').attr('value','');
    $('.main_size_selector_div input[checked]').removeAttr('checked');
    $('.product-information').addClass('variations_loaded');
  },600)
});
$(document).on("click", ".custom_pickup_button", function () {
  $(this).parent().find(".hidden_text").removeClass("hidden_text");
   $('body').find("#cookie_styles").remove();
});

$(document).on("click", ".actual_button", function () {
  $('body').find("#cookie_styles").remove();
});

$(document).on("click", ".product-card-quickview--button", function () {
  setTimeout(function(){
    $('.main_template #product_selected_or_first_available_variant_id').attr('value','');
    $('.main_size_selector_div input[checked]').removeAttr('checked');
    $('.product-information').addClass('variations_loaded');
    console.log('done');
  },2000)
});


